import React from 'react'
// components
import SchemaSection from './components/SchemaSection'
// schemas
import { ChartSchemaNode } from './schema'
// types
import { ChartType } from 'types/charts'
// utils
import { getVisibleEntries } from './utils'

interface Props {
  name: string
  node: ChartSchemaNode
  chartType: ChartType
}

// A section per nested object of the schema: every field of the chart config lives in one
const SchemaFields: React.FC<Props> = ({ name, node, chartType }) => {
  const sections = getVisibleEntries(node, chartType).filter(([, child]) => child.properties)

  return (
    <>
      {sections.map(([key, child]) => (
        <SchemaSection key={key} name={`${name}.${key}`} node={child} chartType={chartType} />
      ))}
    </>
  )
}

export default SchemaFields
